import React, { useState } from "react";
import "../css/AdmissionProcess.css";

const AdmissionProcess = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const faqData = [
    {
      question: "What is the admission process at Sahara Public School?",
      answer:
        "The admission process includes submitting an enquiry, visiting the campus, student interaction or assessment, document verification, and admission confirmation.",
    },
    {
      question: "Which curriculum does Sahara Public School follow?",
      answer:
        "Sahara Public School follows the SEE curriculum of Nepal with a strong focus on academics, character development, and practical learning.",
    },
    {
      question: "Can parents visit the campus before admission?",
      answer:
        "Yes. Parents are welcome to schedule a campus tour to explore our classrooms, laboratories, library, and sports facilities.",
    },
    {
      question: "Are scholarships available?",
      answer:
        "Scholarships are available for eligible students based on academic performance and school policies.",
    },
    {
      question: "How can I contact the admission office?",
      answer:
        "You can contact our admission office by phone, email, or by submitting the online enquiry form on this page.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };
  return (
    <>
      <section
        className="admission-hero"
        style={{
          backgroundImage:
            "linear-gradient(rgba(12,48,86,0.75), rgba(12,48,86,0.75)), url('/images/mr.jpeg')",
        }}
      >
        <div className="admission-hero-container">
          <div className="hero-content">
            <span className="hero-badge">Admissions Open 2026–2027</span>

            <h1>
              Begin Your Child's Journey with
              <span> Sahara Public School</span>
            </h1>

            <p>
              At Sahara Public School, we believe every child deserves an
              education that inspires excellence, creativity, discipline, and
              confidence. Following the SEE curriculum of Nepal, we provide a
              nurturing environment where students develop academically,
              socially, and morally.
            </p>

            <div className="hero-buttons">
  <a href="#enquiry-form" className="btn btn-primary">
    Apply Now
  </a>

  <a href="#admission-process" className="btn btn-secondary">
    View Admission Process
  </a>
</div>
          </div>
        </div>
      </section>
      {}

      <section className="enquiry-section" id="enquiry-form">
        <div className="container">
          <div className="enquiry-wrapper">
            {}

            <div className="enquiry-left">
              <span className="section-tag">ADMISSION ENQUIRY</span>

              <h2>Start Your Admission Journey Today</h2>

              <p>
                Fill out the enquiry form below and our admissions team will
                contact you shortly to guide you through the admission process.
              </p>

              <form className="admission-form">
                <div className="input-grid">
                  <div className="input-group">
                    <label>Student Name</label>
                    <input type="text" placeholder="Enter Student Name" />
                  </div>

                  <div className="input-group">
                    <label>Parent Name</label>
                    <input type="text" placeholder="Enter Parent Name" />
                  </div>

                  <div className="input-group">
                    <label>Email Address</label>
                    <input type="email" placeholder="Enter Email" />
                  </div>

                  <div className="input-group">
                    <label>Phone Number</label>
                    <input type="tel" placeholder="+977" />
                  </div>

                  <div className="input-group">
                    <label>Applying Grade</label>

                    <select>
                      <option>Select Grade</option>

                      <option>Nursery</option>
                      <option>LKG</option>
                      <option>UKG</option>

                      <option>Grade 1</option>
                      <option>Grade 2</option>
                      <option>Grade 3</option>
                      <option>Grade 4</option>
                      <option>Grade 5</option>

                      <option>Grade 6</option>
                      <option>Grade 7</option>
                      <option>Grade 8</option>
                      <option>Grade 9</option>
                      <option>Grade 10</option>
                    </select>
                  </div>

                  <div className="input-group">
                    <label>Curriculum</label>

                    <input type="text" value="SEE Board" readOnly />
                  </div>
                </div>

                <div className="input-group full-width">
                  <label>Message</label>

                  <textarea
                    rows="5"
                    placeholder="Write your message..."
                  ></textarea>
                </div>

               <button className="btn btn-primary">
  Submit Enquiry
</button>
              </form>
            </div>

            {}

            <div className="enquiry-right">
              <div className="info-card">
                <h3>Why Choose Sahara Public School?</h3>

                <ul>
                  <li>✔ SEE Curriculum (Nepal)</li>

                  <li>✔ Experienced & Caring Faculty</li>

                  <li>✔ Smart Digital Classrooms</li>

                  <li>✔ Science & Computer Laboratories</li>

                  <li>✔ Library & Reading Corner</li>

                  <li>✔ Sports & Extracurricular Activities</li>

                  <li>✔ Safe & Secure Campus</li>

                  <li>✔ Leadership & Personality Development</li>
                </ul>
              </div>

              <div className="contact-card">
                <h3>Need Admission Assistance?</h3>

                <div className="contact-box">
                  <h4>Call Us</h4>

                  <p>+977-98XXXXXXXX</p>
                </div>

                <div className="contact-box">
                  <h4>Email</h4>

                  <p>admission@saharapublicschool.edu.np</p>
                </div>

                <div className="contact-box">
                  <h4>Office Hours</h4>

                  <p>Sunday – Friday</p>

                  <p>8:00 AM – 4:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {}

      <section className="admission-process" id="admission-process">
        <div className="container">
          <div className="section-heading">
            <span className="section-tag">ADMISSION PROCESS</span>

            <h2>Your Admission Journey in 5 Simple Steps</h2>

            <p>
              Our admission process is simple, transparent, and designed to make
              your child's enrollment smooth and hassle-free.
            </p>
          </div>

          <div className="process-timeline">
            {}

            <div className="process-card">
              <div className="process-number">01</div>

              <div className="process-icon">📝</div>

              <h3>Submit Enquiry</h3>

              <p>
                Complete the online admission enquiry form or visit our
                admission office to express your interest.
              </p>
            </div>

            <div className="timeline-line"></div>

            {}

            <div className="process-card">
              <div className="process-number">02</div>

              <div className="process-icon">🏫</div>

              <h3>Campus Visit</h3>

              <p>
                Meet our admission counsellors, explore classrooms,
                laboratories, sports facilities and learning environment.
              </p>
            </div>

            <div className="timeline-line"></div>

            {}

            <div className="process-card">
              <div className="process-number">03</div>

              <div className="process-icon">📖</div>

              <h3>Interaction / Assessment</h3>

              <p>
                Students may attend a simple interaction or assessment based on
                the grade they are applying for.
              </p>
            </div>

            <div className="timeline-line"></div>

            {}

            <div className="process-card">
              <div className="process-number">04</div>

              <div className="process-icon">📄</div>

              <h3>Document Verification</h3>

              <p>
                Submit the required academic records and identification
                documents for verification.
              </p>
            </div>

            <div className="timeline-line"></div>

            {}

            <div className="process-card">
              <div className="process-number">05</div>

              <div className="process-icon">🎉</div>

              <h3>Admission Confirmed</h3>

              <p>
                Complete the fee payment process and receive confirmation of
                your child's admission at Sahara Public School.
              </p>
            </div>
          </div>
        </div>
      </section>
      {}

      <section className="required-documents">
        <div className="container">
          <div className="section-heading">
            <span className="section-tag">REQUIRED DOCUMENTS</span>

            <h2>Documents Required for Admission</h2>

            <p>
              Please keep the following documents ready while applying for
              admission. These documents help us complete the admission process
              smoothly and efficiently.
            </p>
          </div>

          <div className="documents-grid">
            {}

            <div className="document-card">
              <div className="document-icon">📚</div>

              <h3>Student Documents</h3>

              <ul>
                <li>Birth Certificate</li>

                <li>Previous Academic Report Card</li>

                <li>Transfer Certificate (If Applicable)</li>

                <li>Character Certificate</li>

                <li>4 Passport Size Photographs</li>

                <li>Migration Certificate (If Required)</li>
              </ul>
            </div>

            {}

            <div className="document-card">
              <div className="document-icon">👨‍👩‍👧</div>

              <h3>Parent / Guardian Documents</h3>

              <ul>
                <li>Citizenship / National ID Copy</li>

                <li>Address Proof</li>

                <li>Passport Size Photograph</li>

                <li>Valid Mobile Number</li>

                <li>Email Address</li>

                <li>Emergency Contact Details</li>
              </ul>
            </div>

            {}

            <div className="document-card">
              <div className="document-icon">📝</div>

              <h3>Additional Information</h3>

              <ul>
                <li>Completed Admission Form</li>

                <li>Medical Information (If Any)</li>

                <li>Transportation Requirement</li>

                <li>Scholarship Documents (If Applicable)</li>

                <li>Special Learning Requirements (Optional)</li>

                <li>Other Supporting Certificates</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {}

      <section className="admission-faq">
        <div className="container">
          <div className="section-heading">
            <span className="section-tag">FREQUENTLY ASKED QUESTIONS</span>

            <h2>Admission FAQs</h2>

            <p>
              Find answers to the most commonly asked questions regarding
              admissions at Sahara Public School.
            </p>
          </div>

          <div className="faq-wrapper">
            {faqData.map((faq, index) => (
              <div
                className={`faq-item ${activeFAQ === index ? "active" : ""}`}
                key={index}
              >
                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.question}</span>

                  <span className="faq-icon">
                    {activeFAQ === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className={`faq-answer ${activeFAQ === index ? "show" : ""}`}
                >
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default AdmissionProcess;
